import React from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import i18next from 'v2/helpers/i18n';
import {
  refineReviewBodySx,
  refineReviewCopySx,
  refineReviewTitleSx,
  refineSummaryBannerSx,
  refineSummaryDismissSx,
  refineSummaryIconSx,
} from './refineStyle';

/** Completed run with nothing left to review — the counterpart of RefineChangesBanner. */
const RefineSummaryBanner = ({
  title = '',
  body = '',
  disabled = false,
  onDismiss = () => null,
}) => (
  <Box
    role="status"
    data-testid="boq-refine-summary-banner"
    sx={refineSummaryBannerSx}
  >
    <Box sx={refineSummaryIconSx}>
      <TaskAltIcon fontSize="small" aria-hidden />
    </Box>
    <Box sx={refineReviewCopySx}>
      <Typography sx={refineReviewTitleSx}>{title}</Typography>
      <Typography sx={refineReviewBodySx}>{body}</Typography>
    </Box>
    <Button
      variant="outlined"
      disabled={disabled}
      onClick={onDismiss}
      sx={refineSummaryDismissSx}
    >
      {i18next.t('boq-refine-dismiss')}
    </Button>
  </Box>
);

export default RefineSummaryBanner;
